import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'
import Icon from '../components/Icon.jsx'

export default function Contact() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Contact</span></nav>
      <header className="page-head">
        <h1>Contact us</h1>
        <p>Questions about sizing, custom glass or your order? We're happy to help before you buy.</p>
      </header>

      <div className="contact-grid">
        <a className="contact-tile" href={SITE.phoneHref}>
          <Icon name="phone" size={26} />
          <h3>Call us</h3>
          <p>{SITE.phone}</p>
          <span className="muted">{SITE.hours}</span>
        </a>
        <a className="contact-tile" href={`mailto:${SITE.email}`}>
          <Icon name="mail" size={26} />
          <h3>Email us</h3>
          <p>{SITE.email}</p>
          <span className="muted">We reply within 1 business day</span>
        </a>
        <a className="contact-tile" href={SITE.mapsUrl} target="_blank" rel="noreferrer">
          <Icon name="pin" size={26} />
          <h3>Warehouse pickup</h3>
          <p>{SITE.address}</p>
          <span className="muted">Pickup by arrangement — call ahead</span>
        </a>
      </div>

      <section className="prose">
        <h2>Need sizing advice?</h2>
        <p>
          Email us photos of your shower space with rough measurements (width of each wall opening and
          ceiling height) and we'll recommend the right configuration and finish — free, no obligation.
        </p>
        <p className="muted">{SITE.legalName} · {SITE.abn}</p>
        <Link to="/shop" className="btn btn-primary">Browse products</Link>
      </section>
    </main>
  )
}
